import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import {
  OrganizationMembershipDto,
  ResponseDto,
  CreateMemberDto,
  ApiError,
} from "@mimber/schema"
import { membersKeys } from "../members.utils"

export const useCreateMember = (
  options?: UseMutationOptions<
    ResponseDto<OrganizationMembershipDto>,
    ApiError,
    CreateMemberDto
  >
): UseMutationResult<
  ResponseDto<OrganizationMembershipDto>,
  ApiError,
  CreateMemberDto
> => {
  guardAppUsage("mimber-organization", "useCreateMember")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (data: CreateMemberDto) => {
      const response = await server.post<
        ResponseDto<OrganizationMembershipDto>
      >("members", data)
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: membersKeys.findAll() })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
